export const getAdmissionTypeLabel = (value = '') => (
  /lateral/i.test(String(value || '')) ? 'Lateral Entry' : 'Regular'
);
